// client/src/dashboard/components/CenterToastHost.js

import React, { useEffect, useState } from "react";

import "./toast.css";
import "../styles/tutor-dashboard-cards.css";

export default function CenterToastHost() {
  const [toast, setToast] = useState(null);

  useEffect(() => {
    const onShow = (e) => {
      const d = e?.detail || {};

      setToast({
        id: d.id || "",
        title: d.title || "",
        text: d.text || "",
        okText: d.okText || "Хорошо",
        cancelText: d.cancelText || "",
        yesText: d.yesText || "Да",
        noText: d.noText || "Нет",
        mode: d.mode || "ok",
        onOk: typeof d.onOk === "function" ? d.onOk : null,
        onCancel: typeof d.onCancel === "function" ? d.onCancel : null,
        onYes: typeof d.onYes === "function" ? d.onYes : null,
        onNo: typeof d.onNo === "function" ? d.onNo : null,
        timeout: Number.isFinite(d.timeout) ? d.timeout : 0,
        hideOk: Boolean(d.hideOk),
      });
    };

    const onHide = (e) => {
      const toastId = e?.detail?.id || "";

      setToast((currentToast) => {
        if (!currentToast) return null;

        /*
         * Если передан id, закрываем только нужную модалку.
         * Другую модалку, открытую позже, не затрагиваем.
         */
        if (toastId && currentToast.id !== toastId) {
          return currentToast;
        }

        return null;
      });
    };

    window.addEventListener("center-toast:show", onShow);
    window.addEventListener("center-toast:hide", onHide);

    return () => {
      window.removeEventListener("center-toast:show", onShow);
      window.removeEventListener("center-toast:hide", onHide);
    };
  }, []);

  useEffect(() => {
    if (!toast?.timeout) return;

    const id = setTimeout(() => {
      setToast(null);
    }, toast.timeout);

    return () => clearTimeout(id);
  }, [toast]);

  if (!toast) return null;

  const close = () => {
    setToast(null);
  };

  return (
    <div
      className="unified-overlay"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 20000,
      }}
    >
      <div className="unified-box">
        {toast.title ? (
          <div className="unified-title">{toast.title}</div>
        ) : null}

        {toast.text ? (
          <div className="unified-text">
            {String(toast.text)
              .split("\n")
              .filter(Boolean)
              .map((line, index) => (
                <div
                  key={index}
                  className={
                    index === 0 ? "unified-text__main" : "unified-text__hint"
                  }
                >
                  {line}
                </div>
              ))}
          </div>
        ) : null}

        <div className="unified-buttons">
          {toast.mode === "confirm" ? (
            <>
              <button
                type="button"
                className="tutor-confirm-yes"
                onClick={() => {
                  const fn = toast.onYes;

                  close();
                  fn?.();
                }}
              >
                {toast.yesText}
              </button>

              <button
                type="button"
                className="tutor-confirm-no"
                onClick={() => {
                  const fn = toast.onNo;

                  close();
                  fn?.();
                }}
              >
                {toast.noText}
              </button>
            </>
          ) : (
            <>
              {!toast.hideOk && (
                <button
                  type="button"
                  className="tutor-confirm-ok"
                  onClick={() => {
                    const fn = toast.onOk;

                    close();
                    fn?.();
                  }}
                >
                  {toast.okText}
                </button>
              )}

              {toast.cancelText && (
                <button
                  type="button"
                  className="tutor-confirm-no"
                  onClick={() => {
                    const fn = toast.onCancel;

                    close();
                    fn?.();
                  }}
                >
                  {toast.cancelText}
                </button>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
